export class ChannelSettingsHandler {
    handle(channelSettingsEvent, widget) {
        if (channelSettingsEvent.channelSettings.enableUpload !== undefined) {
            widget.state.uploadFileEnabled = channelSettingsEvent.channelSettings.enableUpload;
            if (widget.state.uploadFileEnabled) {
                widget.uic.chatScreen.showUploadIcon();
            }
            else {
                widget.uic.chatScreen.hideUploadIcon();
            }
        }
    }
}
